import React from "react";

const STEPS = [
  { title: "Arrive", description: "Land at your destination.", image: "/figma-assets/move/journey-arrive.jpg" },
  {
    title: "Pick Up",
    description: "Collect your rental vehicle from an accredited provider.",
    image: "/figma-assets/move/journey-pickup.jpg",
  },
  { title: "Work", description: "Drive to your workspace or meeting.", image: "/figma-assets/move/journey-work.jpg" },
  { title: "Stay", description: "Check into your hotel or apartment.", image: "/figma-assets/move/journey-stay.jpg" },
  {
    title: "Play",
    description: "Head out to explore, dine or experience.",
    image: "/figma-assets/move/journey-play.jpg",
  },
];

export default function MoveJourney() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
          The Complete Journey
        </p>
        <h2 className="pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          From Arrival to Wherever You're Going Next
        </h2>

        <div className="relative mt-10 flex h-[360px] items-center overflow-hidden rounded-3xl px-6 sm:px-10 lg:h-[590px]">
          <img
            src="/figma-assets/move/journey.jpg"
            alt="Traveller opening a car door"
            className="absolute inset-0 size-full object-cover"
          />
          <p className="relative max-w-[384px] text-[28px] font-bold leading-[1.1] text-white sm:text-[40px] sm:leading-[37.5px]">
            From the airport to your next meeting, hotel or weekend adventure.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-[16px] pt-10 sm:grid-cols-3 lg:grid-cols-5">
          {STEPS.map((step, index) => (
            <div key={step.title}>
              <div className="relative h-[240px] overflow-hidden rounded-2xl sm:h-[350px]">
                <img src={step.image} alt={step.title} className="absolute inset-0 size-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 to-transparent" />
                <span className="absolute left-[12px] top-[12px] text-[12px] font-bold leading-4 text-white/60">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-[16px] left-[16px] text-[16px] font-bold leading-6 text-white">
                  {step.title}
                </span>
              </div>
              <p className="pt-[16px] text-[14px] leading-[22.75px] text-[#717182]">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
